import React, { useContext, useEffect, useState } from "react";
import IViewOptions from "../../../models/IViewOptions";
import * as _ from "lodash-es";
import IOrder_Item from "../../../models/IOrder_Item";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import IOrder from "../../../models/IOrder";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IVendorModel from "../../../models/IVendorModel";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { OrderCreateSalesOrderView } from "./OrderCreateSalesOrderView/OrderCreateSalesOrderView";
import { FormattedMessage } from "react-intl";
import { NumericFormat } from "react-number-format";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import { useLocation } from "react-router-dom";
import { OrderTotalsPanel } from "../../order_entry/OrderTotalsPanel/OrderTotalsPanel";
import "./OrderCreateSalesOrder.scss";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";

type Props = {
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

export const OrderCreateSalesOrder: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const location = useLocation();

    const [order, setOrder] = useState<IOrder>();
    const [orderGuid, setOrderGuid] = useState<string>();
    const [navItems, setNavItems] = useState<IBreadcrumbs[]>([]);
    const [vendorModel, setVendorModel] = useState<IVendorModel>();
    const [viewOptions, setViewOptions] = useState<IViewOptions[]>([]);

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        if (!orderGuid && location.search) {
            const params = new URLSearchParams(location.search);

            const _orderGuid = params.get("order");

            if (_orderGuid) {
                setOrderGuid(_orderGuid);
            }
        }

        setNavItems([
            { title: "Dashboard", url: "/dashboard" },
            { title: "Orders", url: "/orders" },
            {
                title: "Sales Order",
                url: "",
            },
        ]);

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        getOrder();
    }, [orderGuid]);

    const getOrder = () => {
        if (!orderGuid) {
            return;
        }

        const payload: IGetOrderDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid,
        };

        socket.emit(EndpointsEnum.OrderGetOrder, payload);
    };

    const onGetOrder = (data: IOnGetOrderDTO) => {
        setOrder(data.order);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.OrderOnGetOrder, fn: onGetOrder }];

    const getTotals = () => {
        if (!order) {
            return null;
        }

        let subTotal = 0;

        if (!order.sub_total) {
            _.each(order.Order_Items, (orderItem: IOrder_Item) => {
                const rowTotal = Number(orderItem.cost_price_frozen) * Number(orderItem.qty);

                subTotal += rowTotal;
            });
        } else {
            subTotal = order.sub_total;
        }

        let tax_rate = Number(supplierModel.tax_rate);

        if (tax_rate > 1) {
            tax_rate = tax_rate / 100;
        }

        const tax = order.tax || subTotal * tax_rate;
        const grand_total = order.grand_total || subTotal + tax;

        return (
            <div className="col-12 col-md-3 offset-md-9 text-end pe-4">
                <div className="row">
                    <span className="col-6">
                        <FormattedMessage id="sub_total" defaultMessage="Sub Total" description="Sub Total Title" />
                    </span>
                    <span className="col-6">
                        <NumericFormat
                            value={subTotal}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </span>
                </div>

                <div className="row ">
                    <span className="col-6">
                        <FormattedMessage id="tax" defaultMessage="Tax" description="Tax Title" />
                        <span className={"ms-1"}>({supplierModel.tax_rate}%)</span>
                    </span>
                    <span className="col-6">
                        <NumericFormat
                            value={tax}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </span>
                </div>

                <div className="row">
                    <hr className={""} />
                    <span className="col-6">
                        <FormattedMessage id="grand_total" defaultMessage="Grand Total" description="Grand Total Title" />
                    </span>
                    <span className="col-6">
                        <NumericFormat
                            value={grand_total}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </span>
                </div>
            </div>
        );
    };

    return (
        <div className="OrderCreateSalesOrder col-12 mt-2 pb-5">
            {/*<OwViewOptionsPanel viewOptions={viewOptions} onChangeFn={this.handleSupplierChange}/>*/}

            <div className={"row mb-2 d-flex justify-content-between align-items-center flex-wrap"}>
                <div className={"d-inline-flex"}>
                    <Breadcrumbs hasTopMargin={false} navItems={navItems} />
                </div>
                <OwPrintButton/>
            </div>

            {order ? <OrderCreateSalesOrderView order={order} showPhone={true} showEmail={true} showSku={true} showUpc={true} /> : null}

            {order ? (
                <div className={"row"}>
                    <div className={"col-12 justify-content-end d-flex"}>
                        <OrderTotalsPanel
                            shouldHidePricingFn={() => {
                                return false;
                            }}
                            shouldHideTaxJarName={true}
                            order={order}
                            orderItemType={"standard"}
                            isReadOnly={true}
                            lineView={true}
                        />
                    </div>
                </div>
            ) : null}

            {supplierModel.sales_order_footer ? <div className={"text-center"}>{supplierModel.sales_order_footer}</div> : null}
        </div>
    );
};
